module.exports = __webpack_public_path__ + "static/img/hr-director.e8546d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fundamentals/hr-director.png
// module id = 5cc2
// module chunks = 0